import React from "react";
import { Route, Routes } from "react-router-dom";
import HomePage from "../pages/homePage/HomePage";
import CustomNavbar from "../components/navbar/navbar";
import VenuePage from "../pages/venuePage/venuePage";
import EventPage from "../pages/event/event";
import AboutPage from "../pages/about-us/about-us";
import TimetablePage from "../pages/Timetable/Timetable";
import ContactPage from "../pages/contact/ContactPage";
import Footer from "../components/footer/footer";
import EventGallery from "../pages/event/eventGallery";

const AppRoutes = () => {
  return (
    <div className="container-fluid px-0">
      <CustomNavbar />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/venue" element={<VenuePage />} />
        <Route path="/event" element={<EventPage />} />
        <Route path="/event-gallery/:id" element={<EventGallery />} />
        <Route path="/about-us" element={<AboutPage />} />
        <Route path="/timetable" element={<TimetablePage />} />
        <Route path="/contact" element={<ContactPage />} />
      </Routes>
      <Footer/>
    </div>
  );
};

export default AppRoutes;
